import { batch, signal } from "@preact/signals-react"
import { getPreviousDate } from "@ui-seeker/utils"

export const europcarDateRange = signal([getPreviousDate({ days: 7 }), getPreviousDate({ days: 1 })])
export const europcarUsersFilter = signal([])
export const europcarCompaniesFilter = signal([])
export const europcarSitesFilter = signal([])


export const clearSignals = () => batch(() => {
	europcarDateRange.value = [getPreviousDate({ days: 7 }), getPreviousDate({ days: 1 })]
	europcarUsersFilter.value = []
	europcarCompaniesFilter.value = []
	europcarSitesFilter.value = []
})